'use client'

import { useRouter } from 'next/navigation'
import Button from '../button'
import Image from 'next/image'
import Text from '@/components/ui/Text'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

interface UpgradeSuccessModalProps {
  open: boolean
  onClose: () => void
  userSlug: string
  listingSlug?: string
  userType: string
  isTaxExempt?: boolean
}

export function UpgradeSuccessModal({
  open,
  onClose,
  userSlug,
  listingSlug,
  userType,
  isTaxExempt = false,
}: UpgradeSuccessModalProps) {
  const router = useRouter()

  const handleSetUpProfile = () => {
    onClose()
    // Reload page to refresh user data after upgrade
    router.push(userType === 'general' ? `/member/${userSlug}` : `/${userType}/${listingSlug}`)
  }

  const handleNotNow = () => {
    onClose()
    // Reload page to refresh user data after upgrade
    router.push('/discover')
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[626px]">
        <div className="flex flex-col items-center justify-center gap-3 overflow-hidden bg-white px-2 py-6 font-inter text-black">
          <div className="mb-4">
            <Image src="/images/party.svg" alt="success" width={104} height={105} />
          </div>

          <DialogTitle className="text-[24px] font-semibold text-center">Congratulations!</DialogTitle>

          <p className="px-5 pt-4 text-center text-lg text-[#16270C]">
            {isTaxExempt
              ? "Your professional account is pending receipt of tax exempt certificate."
              : "You've unlocked Professional features! Let's set up your profile to get the most out of Culineer."}
          </p>

          <div className="flex mt-6 gap-4 justify-center items-center w-full">
            <Button
              title="Set Up Profile"
              onClick={handleSetUpProfile}
              className="font-normal w-2/3"
            />
            <Button
              title="Not Now"
              onClick={handleNotNow}
              bgGreen={false}
              className="font-normal w-1/3 bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300"
              shadow={false}
            />
          </div>

          <div className="mt-4 flex gap-1 justify-center items-center text-center w-full">
            <span className="text-base text-black">
              Question, compliment or complaint?{' '}
            </span>
            <Text link className="text-base hover:underline xxxs:text-[13px]">
              Contact us!
            </Text>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
